/**
 * Gets form field data as an object
 * @param {HTMLElement} formEl - The form element
 * @returns {Object}
 */
const getFormData = (formEl) => {
  const formData = new FormData(formEl)
  const entries = formData.entries()
  const data = Object.fromEntries(entries)
  return data
}

export {
  getFormData
}